import React, { useState } from 'react';
import { Trophy, ArrowRight, RefreshCw, Home, DollarSign, Bike, Briefcase, Heart } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const quizzes = [
  {
    id: 1,
    title: "Cost of Living Calculator",
    description: "Compare your expenses: Cornwall vs. major cities",
    icon: DollarSign,
    color: "emerald",
    questions: [
      {
        id: 1,
        question: "What is the average house price in Cornwall?",
        options: ["$275,000", "$377,000", "$550,000", "$750,000"],
        correct: 1,
        explanation: "Cornwall's average home price is around $377,000, compared to $1M+ in Toronto."
      },
      {
        id: 2,
        question: "How much lower are commercial lease rates in Cornwall vs Toronto?",
        options: ["20-30%", "50-60%", "70-80%", "About the same"],
        correct: 1,
        explanation: "Commercial lease rates are 50-60% lower, making it ideal for business."
      },
      {
        id: 3,
        question: "Average monthly rent for a 2-bedroom apartment in Cornwall?",
        options: ["$1,200", "$1,600", "$2,200", "$2,800"],
        correct: 0,
        explanation: "Cornwall offers affordable rentals at ~$1,200/month for 2BR, vs $2,500+ in Ottawa."
      },
      {
        id: 4,
        question: "Property tax rate in Cornwall compared to similar-sized cities?",
        options: ["Much higher", "Slightly higher", "Competitive", "Much lower"],
        correct: 2,
        explanation: "Cornwall maintains competitive property tax rates for Ontario municipalities."
      },
      {
        id: 5,
        question: "What percentage can families save on living costs by moving to Cornwall?",
        options: ["10-20%", "25-35%", "40-50%", "Over 60%"],
        correct: 2,
        explanation: "Families typically save 40-50% on overall living costs compared to Toronto/Ottawa."
      }
    ]
  },
  {
    id: 2,
    title: "Recreation & Outdoor Life",
    description: "Test your knowledge of Cornwall's natural attractions",
    icon: Bike,
    color: "teal",
    questions: [
      {
        id: 1,
        question: "How long is Cornwall's waterfront trail system?",
        options: ["15 km", "25 km", "45 km", "65 km"],
        correct: 2,
        explanation: "Cornwall boasts 45km of scenic waterfront trails along the St. Lawrence River."
      },
      {
        id: 2,
        question: "How many parks and recreational facilities does Cornwall maintain?",
        options: ["15", "30", "Over 80", "Over 100"],
        correct: 2,
        explanation: "Cornwall maintains over 80 parks and recreational facilities for residents."
      },
      {
        id: 3,
        question: "What major river borders Cornwall?",
        options: ["Ottawa River", "St. Lawrence River", "Rideau River", "Grand River"],
        correct: 1,
        explanation: "The majestic St. Lawrence River offers boating, fishing, and stunning views."
      },
      {
        id: 4,
        question: "How many golf courses are within 30 minutes of Cornwall?",
        options: ["2-3", "4-6", "7-9", "Over 10"],
        correct: 2,
        explanation: "Cornwall area has 7-9 quality golf courses within a 30-minute drive."
      },
      {
        id: 5,
        question: "Cornwall hosts how many festivals and events annually?",
        options: ["5-10", "20-30", "40-50", "Over 60"],
        correct: 2,
        explanation: "Cornwall celebrates community with 40-50 annual festivals and cultural events."
      }
    ]
  },
  {
    id: 3,
    title: "Business & Economy",
    description: "Discover why businesses choose Cornwall",
    icon: Briefcase,
    color: "blue",
    questions: [
      {
        id: 1,
        question: "How much commercial investment did Cornwall receive in 2023?",
        options: ["$50M", "$100M", "$150M", "$200M"],
        correct: 2,
        explanation: "$150M in commercial investments shows Cornwall's growing economic strength."
      },
      {
        id: 2,
        question: "Cornwall is how far from the US border?",
        options: ["5 minutes", "15 minutes", "30 minutes", "1 hour"],
        correct: 1,
        explanation: "Just 15 minutes to US border, offering excellent cross-border business opportunities."
      },
      {
        id: 3,
        question: "What major highway runs through Cornwall?",
        options: ["Highway 400", "Highway 401", "Highway 417", "Highway 7"],
        correct: 1,
        explanation: "Highway 401 provides direct access to Toronto, Montreal, and beyond."
      },
      {
        id: 4,
        question: "How many major employers operate in Cornwall?",
        options: ["Under 50", "50-100", "100-150", "Over 150"],
        correct: 3,
        explanation: "Over 150 major employers provide diverse job opportunities across sectors."
      },
      {
        id: 5,
        question: "Cornwall's unemployment rate compared to Ontario average?",
        options: ["Much higher", "Slightly higher", "About the same", "Lower"],
        correct: 2,
        explanation: "Cornwall maintains competitive employment rates with Ontario averages."
      }
    ]
  },
  {
    id: 4,
    title: "Healthcare & Services",
    description: "Learn about Cornwall's quality healthcare system",
    icon: Heart,
    color: "rose",
    questions: [
      {
        id: 1,
        question: "How many people does Cornwall Community Hospital serve?",
        options: ["50,000", "100,000", "165,000", "250,000"],
        correct: 2,
        explanation: "Cornwall Community Hospital provides comprehensive care to 165,000 people."
      },
      {
        id: 2,
        question: "How many physicians practice in Cornwall?",
        options: ["50-75", "100-150", "Over 200", "Over 300"],
        correct: 2,
        explanation: "Over 200 physicians provide diverse medical specialties in Cornwall."
      },
      {
        id: 3,
        question: "Average ambulance response time in Cornwall?",
        options: ["Under 8 min", "8-12 min", "12-15 min", "Over 15 min"],
        correct: 0,
        explanation: "Cornwall maintains excellent emergency response times under 8 minutes."
      },
      {
        id: 4,
        question: "How many pharmacies serve the Cornwall area?",
        options: ["5-10", "15-20", "25-30", "Over 30"],
        correct: 2,
        explanation: "25-30 pharmacies ensure convenient access to medications and health services."
      },
      {
        id: 5,
        question: "Cornwall has how many walk-in clinics?",
        options: ["2-3", "4-6", "7-9", "Over 10"],
        correct: 1,
        explanation: "4-6 walk-in clinics provide accessible healthcare without appointments."
      }
    ]
  },
  {
    id: 5,
    title: "Community & Education",
    description: "Explore Cornwall's educational opportunities",
    icon: Home,
    color: "purple",
    questions: [
      {
        id: 1,
        question: "Which college is located in Cornwall?",
        options: ["Algonquin College", "St. Lawrence College", "Georgian College", "Seneca College"],
        correct: 1,
        explanation: "St. Lawrence College offers 100+ programs and serves 6,500+ students."
      },
      {
        id: 2,
        question: "How many elementary and secondary schools serve Cornwall?",
        options: ["10-15", "20-25", "30-35", "Over 40"],
        correct: 2,
        explanation: "30-35 schools provide quality English and French education options."
      },
      {
        id: 3,
        question: "What percentage of Cornwall residents are bilingual (English/French)?",
        options: ["15-20%", "35-40%", "55-60%", "75-80%"],
        correct: 2,
        explanation: "55-60% bilingualism makes Cornwall unique and culturally rich."
      },
      {
        id: 4,
        question: "Cornwall Public Library has how many branches?",
        options: ["1", "2", "3", "4"],
        correct: 1,
        explanation: "2 modern library branches serve the community with extensive resources."
      },
      {
        id: 5,
        question: "Average class size in Cornwall schools compared to Ontario?",
        options: ["Much larger", "Slightly larger", "About same", "Smaller"],
        correct: 3,
        explanation: "Cornwall schools maintain smaller class sizes for better student attention."
      }
    ]
  }
];

export const QuizPage = () => {
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);

  const handleQuizSelect = (quiz) => {
    setSelectedQuiz(quiz);
    setCurrentQuestion(0);
    setScore(0);
    setShowResult(false);
    setSelectedAnswer(null);
    setShowExplanation(false);
  };

  const handleAnswer = (answerIndex) => {
    setSelectedAnswer(answerIndex);
    setShowExplanation(true);

    if (answerIndex === selectedQuiz.questions[currentQuestion].correct) {
      setScore(score + 1);
    }
  };

  const handleNext = () => {
    if (currentQuestion + 1 < selectedQuiz.questions.length) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedAnswer(null);
      setShowExplanation(false);
    } else {
      setShowResult(true);
    }
  };

  const handleRestart = () => {
    setSelectedQuiz(null);
    setCurrentQuestion(0);
    setScore(0);
    setShowResult(false);
    setSelectedAnswer(null);
    setShowExplanation(false);
  };

  const colorClasses = {
    emerald: {
      from: 'from-emerald-400',
      to: 'to-emerald-600',
      bg: 'bg-emerald-600',
      hover: 'hover:bg-emerald-700',
      border: 'border-emerald-200',
      text: 'text-emerald-600'
    },
    teal: {
      from: 'from-teal-400',
      to: 'to-teal-600',
      bg: 'bg-teal-600',
      hover: 'hover:bg-teal-700',
      border: 'border-teal-200',
      text: 'text-teal-600'
    },
    blue: {
      from: 'from-blue-400',
      to: 'to-blue-600',
      bg: 'bg-blue-600',
      hover: 'hover:bg-blue-700',
      border: 'border-blue-200',
      text: 'text-blue-600'
    },
    rose: {
      from: 'from-rose-400',
      to: 'to-rose-600',
      bg: 'bg-rose-600',
      hover: 'hover:bg-rose-700',
      border: 'border-rose-200',
      text: 'text-rose-600'
    },
    purple: {
      from: 'from-purple-400',
      to: 'to-purple-600',
      bg: 'bg-purple-600',
      hover: 'hover:bg-purple-700',
      border: 'border-purple-200',
      text: 'text-purple-600'
    }
  };

  // Quiz Selection Screen
  if (!selectedQuiz) {
    return (
      <section className="pt-24 pb-20 bg-gradient-to-br from-slate-50 to-emerald-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 space-y-4">
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900">
              Quality of Life Quizzes
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Test your knowledge about living in Cornwall with our data-driven quizzes
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {quizzes.map((quiz) => {
              const IconComponent = quiz.icon;
              const colors = colorClasses[quiz.color];
              
              return (
                <Card
                  key={quiz.id}
                  className={`border-2 ${colors.border} hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1`}
                  onClick={() => handleQuizSelect(quiz)}
                >
                  <CardHeader className="space-y-4">
                    <div className={`w-16 h-16 bg-gradient-to-br ${colors.from} ${colors.to} rounded-2xl flex items-center justify-center`}>
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-slate-900">
                      {quiz.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-slate-600 mb-4">{quiz.description}</p>
                    <div className="flex items-center justify-between text-sm text-slate-500">
                      <span>{quiz.questions.length} Questions</span>
                      <ArrowRight className="w-5 h-5" />
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  const colors = colorClasses[selectedQuiz.color];

  // Result Screen
  if (showResult) {
    const percentage = (score / selectedQuiz.questions.length) * 100;
    let message = '';
    if (percentage === 100) message = 'Perfect! You\'re a Cornwall expert!';
    else if (percentage >= 80) message = 'Excellent! You know Cornwall well!';
    else if (percentage >= 60) message = 'Good job! You\'re learning about Cornwall!';
    else message = 'Keep exploring! There\'s so much to discover about Cornwall!';

    return (
      <section className="pt-24 pb-20 bg-gradient-to-br from-slate-50 to-emerald-50 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className={`border-2 ${colors.border} shadow-xl`}>
            <CardHeader className="text-center space-y-6 py-12">
              <div className={`w-24 h-24 bg-gradient-to-br ${colors.from} ${colors.to} rounded-full flex items-center justify-center mx-auto`}>
                <Trophy className="w-12 h-12 text-white" />
              </div>
              <CardTitle className="text-4xl font-bold text-slate-900">
                Quiz Complete!
              </CardTitle>
              <div className="space-y-2">
                <div className={`text-6xl font-bold ${colors.text}`}>
                  {score} / {selectedQuiz.questions.length}
                </div>
                <p className="text-2xl text-slate-700">{message}</p>
              </div>
            </CardHeader>
            <CardContent className="text-center space-y-6 pb-12">
              <div className="bg-gradient-to-r from-emerald-100 to-teal-100 rounded-xl p-6">
                <p className="text-slate-700 text-lg">
                  All quiz data is based on real statistics and information about Cornwall, Ontario. 
                  Want to learn more about making Cornwall your home?
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  onClick={handleRestart}
                  variant="outline"
                  className={`border-2 ${colors.border} ${colors.text} hover:bg-emerald-50 px-8 py-6 text-lg`}
                >
                  <RefreshCw className="w-5 h-5 mr-2" />
                  Try Another Quiz
                </Button>
                <Button
                  onClick={() => window.location.href = '/contact'}
                  className={`${colors.bg} ${colors.hover} text-white px-8 py-6 text-lg`}
                >
                  Contact Us
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    );
  }

  // Question Screen
  const question = selectedQuiz.questions[currentQuestion];

  return (
    <section className="pt-24 pb-20 bg-gradient-to-br from-slate-50 to-emerald-50 min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={handleRestart}
            className="text-slate-600 hover:text-slate-900"
          >
            ← Back to Quizzes
          </Button>
        </div>

        <Card className={`border-2 ${colors.border} shadow-xl`}>
          <CardHeader className="space-y-4">
            <div className="flex items-center justify-between">
              <span className={`text-sm font-medium ${colors.text}`}>
                Question {currentQuestion + 1} of {selectedQuiz.questions.length}
              </span>
              <span className="text-sm font-medium text-slate-600">
                Score: {score}
              </span>
            </div>
            <div className="w-full bg-slate-200 rounded-full h-2">
              <div
                className={`${colors.bg} h-2 rounded-full transition-all duration-500`}
                style={{ width: `${((currentQuestion + 1) / selectedQuiz.questions.length) * 100}%` }}
              ></div>
            </div>
            <CardTitle className="text-2xl font-bold text-slate-900">
              {question.question}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 pb-8">
            {question.options.map((option, index) => (
              <button
                key={index}
                onClick={() => !showExplanation && handleAnswer(index)}
                disabled={showExplanation}
                className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-300 ${
                  !showExplanation
                    ? 'border-slate-200 hover:border-emerald-400 hover:bg-emerald-50 bg-white'
                    : selectedAnswer === index
                    ? index === question.correct
                      ? `${colors.border} bg-emerald-100 text-emerald-900`
                      : 'border-red-500 bg-red-100 text-red-900'
                    : index === question.correct
                    ? `${colors.border} bg-emerald-100 text-emerald-900`
                    : 'border-slate-200 bg-slate-50 text-slate-400'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                    !showExplanation
                      ? 'border-slate-300'
                      : selectedAnswer === index
                      ? index === question.correct
                        ? 'border-emerald-600 bg-emerald-600 text-white'
                        : 'border-red-600 bg-red-600 text-white'
                      : index === question.correct
                      ? 'border-emerald-600 bg-emerald-600 text-white'
                      : 'border-slate-300'
                  }`}>
                    <span className="text-sm font-bold">{String.fromCharCode(65 + index)}</span>
                  </div>
                  <span className="font-medium">{option}</span>
                </div>
              </button>
            ))}

            {showExplanation && (
              <div className="mt-6 p-4 bg-blue-50 border-2 border-blue-200 rounded-lg">
                <p className="text-sm font-semibold text-blue-900 mb-2">Did you know?</p>
                <p className="text-sm text-blue-800">{question.explanation}</p>
              </div>
            )}

            {showExplanation && (
              <Button
                onClick={handleNext}
                className={`w-full ${colors.bg} ${colors.hover} text-white py-6 text-lg mt-6`}
              >
                {currentQuestion + 1 < selectedQuiz.questions.length ? 'Next Question' : 'See Results'}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
